module.exports = __webpack_public_path__ + "static/media/bttw2.43ffae0a.jpg";